import { CacheLookupPolicy, IPublicClientApplication } from '@azure/msal-browser';
import { AUTH_SCOPES } from 'features/auth/authConfig';
import { logger } from 'shared/logger';

export default async function getJwtAuthToken(msalInstance: IPublicClientApplication, forceRefresh = false): Promise<{ 
    token: string | null;
    interactionRequired: boolean;
 }> {
    const accounts = msalInstance.getAllAccounts();

    if (!accounts.length) {
        return { token: null, interactionRequired: true };
    }

    try {
        const account = accounts[0];

        const response = await msalInstance.acquireTokenSilent({
            scopes: AUTH_SCOPES,
            account,
            forceRefresh,
            cacheLookupPolicy: CacheLookupPolicy.AccessTokenAndRefreshToken
        });

        return { token: response.accessToken, interactionRequired: false };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
        logger.error('Error acquiring token silently', error);   

        if (error.errorCode === 'interaction_required') {
            return { token: null, interactionRequired: true };
        }
    }

    return { token: null, interactionRequired: false };
}
